import { useState, useCallback } from "react";
import { makeStyles } from "@mui/styles";
import {
  Button,
  Card,
  CardContent,
  Dialog,
  Grid,
  TextField,
} from "@mui/material";
import { useSelector } from "react-redux";
import Breadcrumb from "../../App/Components/Navigation/Breadcrumbs/Breadcrumbs";
import { selectUserInformation } from "../../App/State/Slices/UserInformationSlice";
import ConfirmationModal from "../../App/Components/Modals/ConfirmationModal";
import { useResetPasswordMutation } from "../../App/Queries/UserQueries";
import { useNotification } from "../../App/State/Hooks/useNotificationHooks";

function ProfilePage() {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "50%",
      marginBottom: "50px",
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },
    cardContainer: {
      [theme.breakpoints.down("md")]: {
        width: "100%",
        overflowY: "scroll",
      },
      display: "flex",
      flexDirection: "column",
      marginBottom: "20px",
      width: "50%",
    },
    error: {
      color: theme.palette.error.main,
    },
  }));

  const classes = useStyles();

  const user = useSelector(selectUserInformation);
  const [modal, setModal] = useState(false);
  const { mutateAsync: resetUserPassword, isLoading: resetIsLoading } = useResetPasswordMutation();
  const { displaySuccess, displayError } = useNotification();

  //Call the ABAC API endpoint for resetting a User's Auth0 password
  const handleResetPassword = useCallback(
    async function resetPassword() {
      if (!resetIsLoading) {
        await resetUserPassword(user?.email, {
          onError: () => {
            displayError("Error resetting password!");
          },
          onSuccess: () => {
            displaySuccess(`Reset email sent to ${user?.email}!`);
          }
        });
      }
    },
    [
      user?.email,
      displayError,
      displaySuccess,
      resetIsLoading,
      resetUserPassword,
    ]
  );

  return (
    <>
      <div className="page-container">
        <Breadcrumb />
        <h1 className="page-title">Profile</h1>
        <div className={classes.root}>
          <Grid className={classes.cardContainer}>
            <Card className={classes.card}>
              <CardContent>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={12}>
                    <TextField
                      placeholder="Username"
                      label="Username"
                      variant="standard"
                      fullWidth
                      value={user?.nickname}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <TextField
                      placeholder="Email Address"
                      label="Email Address"
                      variant="standard"
                      fullWidth
                      value={user?.email}
                      disabled
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    container
                    justifyContent="flex-end"
                  >
                    <Button
                      style={{ marginTop: "20px", marginRight: "8px" }}
                      className={classes.sensitiveButton}
                      type="submit"
                      variant="contained"
                      color="secondary"
                      onClick={() => setModal(true)}
                    >
                      Reset Password
                    </Button>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </div>
      </div>
      <Dialog open={modal} onClose={() => setModal(false)}>
        <ConfirmationModal
          question="Reset Password?"
          func={() => handleResetPassword()}
          closeModal={() => setModal(false)}
        />
      </Dialog>
    </>
  );
}

export default ProfilePage;
